import { render } from "./selection-setting.vue?vue&type=template&id=064e46db&lang=pug"
import script from "./selection-setting.vue?vue&type=script&lang=js"
export * from "./selection-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__